<template>
    <div>
        <v-row
            no-gutters
        >
            <v-col :style="$vuetify.breakpoint.smAndDown ? {} : { 'border-bottom': '1px solid lightgrey' }">
                <v-card
                    class="py-1 elevation-4"
                    flat
                    :class="$vuetify.breakpoint.smAndDown ? '' : 'px-1'"
                >
                    <NewFilterBar
                        transparent
                        :available-filters="filterHelper.getAvailableFilters()"
                        :before-route-change="filterHelper.setFilterParamsIfEmpty.bind(filterHelper)"
                        @route_change="debouncedBackendQuery"
                    >
                        <template v-slot:left="{filters, filterAdd}">
                            <v-col style="height: 46px" class="d-flex align-center z-index-lvl-2" :class="showSelectionCheckbox ? 'ml-2' : 'ml-1'">
                                <v-tooltip v-if="showSelectionCheckbox === false" bottom>
                                    <template v-slot:activator="{ on }">
                                        <icon-button
                                            icon="CheckCheck"
                                            @click="toggleBulkAction"
                                        />
                                    </template>
                                    {{ $t("Show multiselect") }}
                                </v-tooltip>
                                <v-simple-checkbox
                                    v-else
                                    class="mr-2"
                                    :value="selectedListIds.value > 0"
                                    style="margin-left: 2px"
                                    color="primary"
                                    @input="selectTasks"
                                />
                            </v-col>
                        </template>
                        <template v-slot:right="{filters, filterAdd}">
                            <AddFilterButton
                                :filters="filters"
                                @add_filter="filterAdd($event)"
                            />
                            <div v-show="column_controller_enabled">
                                <ColumnController
                                    :headers="fieldColumns"
                                    :visible-headers="filterHelper.getUrlParam('columns')"
                                    @update_columns="filterHelper.setColumns($event)"
                                />
                            </div>
                            <v-menu
                                content-class="overflow-y-hidden dropmenu"
                                bottom
                                offset-y
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <icon-button
                                        :on="on"
                                        icon="MoreVertical"
                                    />
                                </template>
                                <v-list dense>
                                    <v-list-item
                                        v-if="object_type === 'project' && canManageClient"
                                        class="menu-list-item"
                                        style="height: 32px !important; min-height: 32px !important;"
                                        @click="editWorkflow()"
                                    >
                                        <v-list-item-icon>
                                            <icon icon="Pencil" />
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ $t("Edit workflow") }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="object_type === 'project' && canManageClient"
                                        class="menu-list-item"
                                        style="height: 32px !important; min-height: 32px !important;"
                                        @click="$emit('clone_project')"
                                    >
                                        <v-list-item-icon>
                                            <icon icon="Pencil" />
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ $t("Duplicate project") }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item
                                        class="menu-list-item"
                                        style="height: 32px !important; min-height: 32px !important;"
                                        @click="toggleBulkAction"
                                    >
                                        <v-list-item-icon>
                                            <icon icon="CheckCheck" />
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{
                                                    showSelectionCheckbox === true
                                                        ? $t("Hide multiselect")
                                                        : $t("Show multiselect")
                                                }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action v-if="textForOS !== ''">
                                            <v-chip
                                                label
                                                class="tag"
                                            >
                                                {{ textForOS }}
                                            </v-chip>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-list-item
                                        class="menu-list-item"
                                        style="height: 32px !important; min-height: 32px !important;"
                                        @click="column_controller_enabled = !column_controller_enabled"
                                    >
                                        <v-list-item-icon>
                                            <icon icon="Table" />
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ $t("Edit fields") }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action v-if="column_controller_enabled">
                                            <icon color="primary" icon="Check" />
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-list-item
                                        class="menu-list-item"
                                        style="height: 32px !important; min-height: 32px !important;"
                                        @click="filterHelper.resetFilters()"
                                    >
                                        <v-list-item-icon>
                                            <icon icon="RotateCw" />
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ $t("Reset layout") }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                    </NewFilterBar>
                </v-card>
            </v-col>
        </v-row>
        <div style="position:relative;">
            <BulkActionBar
                :items="tasks"
                :selected-list-ids="selectedListIds"
                :is-mobile="$vuetify.breakpoint.smAndDown"
                :relative-elem="clientTasksList"
            />

            <TasksList
                ref="clientTasksList"
                :tasks="tasks"
                :chip-columns="visible_headers"
                :is-mobile="$vuetify.breakpoint.smAndDown"
                :client-tasks="true"
            >
                <template v-slot:row="{ item, chipColumns, showClientName, isMobile ,index}">
                    <TaskListRow
                        :item="item"
                        :test-id="'tasks-list-row_' + index"
                        :chip-columns="chipColumns"
                        :show-client="showClientName"
                        :is-mobile="isMobile"
                        :client-id="client_id"
                        :show-selection-checkbox="showSelectionCheckbox"
                        :show-dependencies="object_type === 'project'"
                        :color-ranges="colorRanges"
                    />
                </template>
                <template v-slot:bottom="{}">
                    <DependencyArrows
                        :dependencies="taskDependencies"
                        :padding-left="-12"
                    />
                </template>
            </TasksList>
        </div>
        <v-row
            v-if="!opening"
            no-gutters
        >
            <v-col class="text-center">
                <v-btn
                    v-if="tasks.length < tasks_total"
                    text
                    color="primary"
                    class="mt-2 mb-5"
                    :loading="loadMoreLoading"
                    @click="onLoadMore"
                >
                    {{ $t("Show more") }}
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { $t } from "@/i18n";
import { debounce } from "throttle-debounce";
import TasksList from "./TasksList";
import ColumnController from "../../components/ColumnController";
import TaskListRow from "./TaskListRow";
import NewFilterBar from "../../components/NewFilterBar";
import BulkActionBar from "../../components/BulkActionBar/BulkActionBarClientsTasks";
import AddFilterButton from "../../components/NewFilterBar/components/AddFilterButton";
import { computed, onMounted, onUnmounted, ref, watch } from "@vue/composition-api";
import CustomFieldsModule from "../../store/modules/custom_fields";
import AccountModule from "../../store/modules/account";
import BookmarkModule from "../../store/modules/bookmark";
import { Router } from "../../composables/Router";
import TaskModule from "../../store/modules/task";
import AppModule from "../../store/modules/app";
import ClientModule from "../../store/modules/client";
import {useTopicStore} from "../../store/modules/topic";
import { getFilterHelper } from "../../components/NewFilterBar/FilterBar";
import DependencyArrows from "../../components/Task/DependencyArrows";
import { getColorRanges } from "../../composables/use-task-color";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import ProjectModule from "@/store/modules/project";
import {useMemberStore} from "../../store/modules/member";


export default {
    name: "ObjectTasksList",
    components: {
        TasksList,
        ColumnController,
        TaskListRow,
        NewFilterBar,
        AddFilterButton,
        BulkActionBar,
        DependencyArrows
    },
    props: {
        client: {
            type: Object,
            default: null
        },
        project: {
            type: Object,
            default: null
        }
    },
    setup(props, ctx) {
        const { fetchCustomFields, account_custom_fields } = CustomFieldsModule();
        const topicStore = useTopicStore()
        const { current_account, isFeatureEnabled, available_accounts } = AccountModule();
        const router = Router();
        const memberStore = useMemberStore()
        const appModule = AppModule();
        const { isEventTypeCompany } = ProjectModule();
        const { page_title, textForOS, rights_masks } = AppModule();
        const { expandClientMembers, current_client } = ClientModule();
        const { fetchTasks,
                clearTasks,
                tasks_list,
                tasks_total,
                clearAllSelectedListIds,
                selectedListIds,
                setSelectedListIds,
                projects } = TaskModule();

        const has_event_type_company = computed(() => {
            return !!available_accounts.value.find(
                (account) => isEventTypeCompany(account.id)
            );
        })

        const personIdList = computed(() => {
            if (!current_client.value) {
                return null
            }

            return expandClientMembers(false, memberStore.getMembersByCompany(current_client.value.account_id));
        })

        const column_controller_enabled = ref(false);
        const refresh = ref(false);
        const columns = computed(() => {
            let columns = [
                { text: $t("Topic"), value: "topic", align: "", class: "text-no-wrap" },
                { text: $t("Client portal"), value: "client_portal", class: "text-no-wrap", align: "" },
                { text: $t("Checklist"), value: "checklist", class: "text-no-wrap", align: "" }
            ]

            if (props.project != null)
                columns.push(
                    { text: $t("Depends on"), value: "depends_on", class: "text-no-wrap", align: "", object_type: "project" }
                );
            if (!props.project) {
                columns.push(
                    { text: has_event_type_company.value ? $t('Event') : $t("Project"), value: "project", class: "text-no-wrap", align: ""}
                );
            }

            return columns
        });

        const object_id = computed(() =>{
            if (router.currentRoute.params.id) {
                return parseInt(router.currentRoute.params.id)
            }
        });
        const object = computed(() => {
            if (props.client != null) return props.client;
            if (props.project != null) return props.project;
            return null;
        });
        const object_type = computed(() => {
            if (props.client != null) return "client";
            if (props.project != null) return "project";
            return null;
        });
        const bookmarkType = computed(() => {
            return object_type.value === "project" ? "project_tasks" : "client_tasks"
        })
        const canManageClient = computed(() => {
            return (object.value.rights & rights_masks.value.manage_client) === rights_masks.value.manage_client;
        });
        const client_id = computed(() => {
            if (props.client != null) return props.client.id;
            if (props.project != null) return props.project.id;
            return null;
        });
        const client_members = computed(() => object.value.members);
        const defaultItemsPerPage = 50
        const loadMoreLoading = ref(false);
        const opening = ref(true);
        const showSelectionCheckbox = ref(false);
        const clientTasksList = ref(null);
        const taskDependencies = computed(() => {
            let ret = [];
            for (let t of tasks_list.value) {
                if (!t.depends_on) continue;
                for (let depends_on_id of t.depends_on) {
                    ret.push([t.id, depends_on_id]);
                }
            }
            return ret;
        });
        const colorRanges = computed(() => {
            let ret = {};
            for (let project of projects.value) {
                if (!isFeatureEnabled(project.account_id, "project", false)) continue;
                if (appModule.progress_steps.value[project.account_id] === undefined) continue;
                if (appModule.custom_fields.value[project.account_id] === undefined) continue;
                ret[project.id] = getColorRanges(
                    appModule.progress_steps.value[project.account_id], project, appModule.custom_fields.value[project.account_id]
                );
            }
            return ret;
        });

        watch (object, (value, previous) => {
            page_title.value = value.name;
            if ((value && previous && value.account_id !== previous.account_id) || (value && !previous)) {
                fetchCustomFields(value.account_id, 'task', 0, false).catch(ex => errorDialog.showError(ex));
            }
        }, { immediate: true });
        const acc_custom_fields = account_custom_fields(object.value.account_id);
        const fieldColumns = computed(() => {
            const c_fields = acc_custom_fields.value.map(cf => {
                return {
                    text: cf.title,
                    value: cf.name,
                    class: ""
                };
            });
            return [
                ...columns.value.filter(x => x.object_type === undefined || x.object_type === object_type.value),
                ...c_fields
            ];
        });
        const visible_headers = computed(() => {
            if (filterHelper.getUrlParam('columns')) {
                return fieldColumns.value.filter(x => filterHelper.getUrlParam('columns').includes(x.value))
            } else {
                return fieldColumns.value
            }
        })

        const backendQuery = () => {
            let fetchTodo = 1;
            let filters = filterHelper.getOnlyRelevantQueryParams();
            filters.itemsPerPage = filterHelper.getUrlParam("itemsPerPage");

            let params = {
                meta_filter: object_type.value === "project" ? "project_tasks" : "client_tasks",
                fetch_todo: fetchTodo,
                ...filters
            };
            if (object_type.value === "project") params["project_id"] = object_id.value;
            else {
                if (params['client_id_list']) {
                    params['client_id_list'].push(object_id.value)
                } else {
                    // Temporary hack to load url parameter every time request is made, currently object_id is not reactive
                    params['client_id_list'] = [parseInt(router.currentRoute.params.id)]
                    //params['client_id_list'] = [object_id.value]
                }
            }

            fetchTasks(params)
                .then(() => {
                    loadMoreLoading.value = false;
                    opening.value = false;
                    ctx.emit('fetched-tasks')
                })
                .catch(ex => errorDialog.showError(ex));

            if (object.value && object.value.account_id) {
                let currentSaveAsDefault = {}

                try {
                    let localStorageBookmarks = localStorage.getItem('autoSavedBookmarks')
                    if (localStorageBookmarks) {
                        currentSaveAsDefault = JSON.parse(localStorageBookmarks)
                    }
                } catch (e) {
                    // Pass
                }

                currentSaveAsDefault[bookmarkType.value] = filters
                localStorage.setItem('autoSavedBookmarks', JSON.stringify(currentSaveAsDefault))
            }
        };
        const onLoadMore = () => {
            loadMoreLoading.value = true;
            let itemsPerPage = parseInt(filterHelper.getUrlParam('itemsPerPage')) ? parseInt(filterHelper.getUrlParam('itemsPerPage')) : defaultItemsPerPage
            filterHelper.setUrlParam('itemsPerPage', itemsPerPage + defaultItemsPerPage)
            backendQuery();
        };

        let promise_list = [];

        const debouncedBackendQuery = debounce(300, false, () => {
            backendQuery();
        });

        const topics = computed(() => topicStore.getAllTopics())

        const filterHelper = getFilterHelper({
            filters: [
                {
                    key: "dates_list",
                    value: [
                        new Date().calcMonthStart().formatSysDate(),
                        new Date().calcMonthEnd().formatSysDate(),
                        "som_0",
                        "eom_0"
                    ],
                    extraItems: [
                        //{ title: $t("Any time"), start: "d_-1000", end: "d_1000" },
                        { title: $t("Today"), start: "d_0", end: "d_0" },
                        { title: $t("Yesterday"), start: "d_-1", end: "d_-1" },
                        { title: $t("This week"), start: "sow_0", end: "eow_0" },
                        { title: $t("Last week"), start: "sow_-1", end: "eow_-1" },
                        { title: $t("This month"), start: "som_0", end: "eom_0" },
                        { title: $t("Last month"), start: "som_-1", end: "eom_-1" },
                    ],
                    default: object_type.value === "client",
                    deselect: object_type.value === "project",
                },
                { key: "task_status", value: [], default: true },
                { key: "topic_id_list", value: [], items: topics },
                { key: "person_id_list", value: [] ,items: personIdList },
                { key: "is_important", value: ["1"]},
                { key: "is_extra", value: ["1"]},
                { key: "is_recurring", value: ["1"]},
                { key: "follow", value: ["1"]},
                { key: "is_commented", value: ["1"]},
                { key: "is_tracked_time", value: ["1"]},
                { key: "is_cp", value: ["1"], feature: 'client_portal'}
            ].filter(x => x.feature === undefined || isFeatureEnabled(object.value.account_id, x.feature, false)),
            table_parameters:[
                { key: "sortBy", value: "name" },
                { key: "sortDesc", value: false },
                { key: "itemsPerPage", value: defaultItemsPerPage },
            ],
            custom_parameters:[
                { key: "columns", value: ["topic", "comments", "checklist", "client_portal", "project"]},
                { key: "groupBy", value: "" },
                { key: "groupDesc", value: []},
            ],
            bookmarkType: bookmarkType.value
        })

        const onResetLayoutClick = () => {
            router.push({ name: "client_profile_tasks", params: { id: object_id.value }});
            filterHelper.resetFilters();
            refresh.value = !refresh.value;
        };

        onUnmounted(function () {
            clearAllSelectedListIds()
            clearTasks();
        });

        onMounted(function () {
            toggleSelectionCheckbox();
        })

        function toggleSelectionCheckbox() {
            window.addEventListener("keydown", e => {
                if (navigator.userAgent.indexOf("Mac") !== -1) {
                    if (e.metaKey) {
                        toggleBulkAction();
                    }
                } else {
                    if (e.ctrlKey) {
                        toggleBulkAction();
                    }
                }
            });
        }

        function toggleBulkAction() {
            clearAllSelectedListIds();
            showSelectionCheckbox.value = !showSelectionCheckbox.value;
        }

        const selectTasks = () => {
            tasks_list.value.forEach(task => {
                let id = task.id || task.virtual_id
                setSelectedListIds(id);
            });
        };
        const editWorkflow = () => {
            ctx.root._router.push({ name: "project_edit_workflow", params: { id: object.value.id, action: "none" }});
        }

        return {
            refresh,
            client_id,
            tasks: tasks_list,
            tasks_total,
            opening,
            loadMoreLoading,
            backendQuery,
            columns,
            fieldColumns,
            onResetLayoutClick,
            filterHelper,
            visible_headers,
            client_members,
            column_controller_enabled,
            onLoadMore,
            debouncedBackendQuery,
            toggleBulkAction,
            showSelectionCheckbox,
            selectedListIds,
            setSelectedListIds,
            clientTasksList,
            textForOS,
            taskDependencies,
            colorRanges,
            object_type,
            canManageClient,
            selectTasks,
            editWorkflow
        };
    }
};
</script>
